import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSumpPump = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 103.54,
	height: 186.77,
	viewBox: "0 0 103.54 186.77",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 96.77 156.77 A 20.0 20.0 0.0 0 1 96.77 186.77 L 6.77 186.77 A 20.0 20.0 0.0 0 1 6.77 156.77 Z M 36.77 6.77 A 20.0 20.0 0.0 0 1 66.77 6.77 L 66.77 36.77 A 20.0 20.0 0.0 0 1 36.77 36.77 Z M 76.77 148.27 L 96.77 148.27 M 86.77 148.27 L 86.77 156.77 M 36.77 36.77 L 66.77 36.77 M 36.77 6.77 L 66.77 6.77",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 49.77,
			y: 43.27,
			width: 4,
			height: 113.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.77,
			y: 75.77,
			width: 70,
			height: 14,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 16.77 82.77 L 86.77 82.77",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgSumpPump;
